import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { hydrateSessionFromLogin, isAuth, restoreSession } from "../helper/auth";
import { clearAuthToken } from "../helper/authCookie";
import swal from "sweetalert";

function LoginAdmin() {
    const nav = useNavigate();
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
        let cancelled = false;
        (async () => {
            let u = isAuth();
            if (!u) u = await restoreSession();
            if (cancelled || !u) return;
            if (u.role === "admin") nav("/admin");
            else if (u.role === "staff") nav("/dashboard");
        })();
        return () => { cancelled = true; };
    }, [nav]);

    const loginHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post('api/auth/login-admin', {
                username,
                password
            }, { withCredentials: true });

            if (response.data.user?.role === "admin" && response.data.token) {
                clearAuthToken();
                hydrateSessionFromLogin(response.data.user, response.data.token);
                window.location.assign('/admin');
                return;
            }

            swal("Gagal", "Anda tidak memiliki akses admin!", "error");
        } catch (err) {
            const message = err?.response?.data?.message || "Username atau Password salah!";
            swal("Gagal", Array.isArray(message) ? message.join(', ') : message, "error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen bg-zafu-cream flex items-center justify-center px-4 py-10">
            <div className="w-full max-w-4xl grid md:grid-cols-2 rounded-zafu-xl overflow-hidden shadow-zafu-lg bg-white">
                <div className="hidden md:flex flex-col justify-between bg-gradient-to-br from-zafu-green to-zafu-green-soft p-10 text-white relative">
                    <div>
                        <div className="w-14 h-14 rounded-full bg-zafu-cream text-zafu-green font-display font-bold text-2xl flex items-center justify-center mb-6">
                            Z
                        </div>
                        <p className="text-white/70 text-xs tracking-[0.2em] uppercase mb-2">Zafu Residence</p>
                        <h1 className="font-display text-4xl font-semibold leading-tight mb-3">Panel Admin</h1>
                        <p className="text-white/80 text-sm leading-relaxed max-w-xs">
                            Kelola absensi staff, devisi, dan laporan kehadiran dari satu tempat.
                        </p>
                    </div>
                    <p className="text-white/50 text-xs">©2026 Zafu Residence</p>
                </div>

                <div className="p-8 md:p-10 flex flex-col justify-center">
                    <div className="md:hidden w-12 h-12 rounded-full bg-zafu-green text-zafu-cream font-display font-bold text-xl flex items-center justify-center mb-4">
                        Z
                    </div>
                    <h2 className="font-display text-2xl text-zafu-ink mb-1">Zafu Residence</h2>
                    <p className="text-zafu-muted text-sm mb-6">Login Admin</p>

                    <form onSubmit={loginHandler} className="space-y-4">
                        <div className="zafu-input">
                            <input
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full outline-none border-none bg-transparent text-base"
                                type="text"
                                required
                                placeholder="Username"
                            />
                        </div>
                        <div className="zafu-input">
                            <input
                                className="w-full outline-none border-none bg-transparent text-base"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Password"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="zafu-btn-primary w-full disabled:opacity-50"
                        >
                            {loading ? "Loading..." : "Login Admin"}
                        </button>
                    </form>

                    <div className="text-center mt-5">
                        <NavLink to="/login" className="text-sm text-zafu-muted hover:text-zafu-green">
                            Login sebagai Staff?
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginAdmin;
